import React, { useEffect, useState, useRef } from 'react';
import { ZapIcon, ShieldCheckIcon, UserIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function WhatIsDTech() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  const items = en ? [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-303" />,
    label: 'Electric drive',
    text: 'A powerful motor for easy climbing with minimal operator effort.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-304" />,
    label: 'Control & safety',
    text: 'Integrated automatic brake guarantees load stability at all times.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-305" />,
    label: 'Single operator',
    text: 'Designed so one person can safely handle heavy cargo without extra help.'
  }] : ru ? [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-306" />,
    label: 'Электрический привод',
    text: 'Мощный мотор для лёгкого подъёма с минимальными усилиями оператора.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-307" />,
    label: 'Контроль и безопасность',
    text: 'Встроенный автоматический тормоз гарантирует стабильность груза в любой момент.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-308" />,
    label: 'Один оператор',
    text: 'Разработано так, чтобы один человек мог безопасно перемещать тяжёлые грузы без дополнительной помощи.'
  }] : [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-309" />,
    label: 'Električni pogon',
    text: 'Snažan motor za lako savladavanje uspona uz minimalan napor operatera.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-310" />,
    label: 'Kontrola i bezbednost',
    text: 'Integrisana automatska kočnica garantuje stabilnost tereta u svakom trenutku.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-311" />,
    label: 'Jedan operater',
    text: 'Dizajnirano da jedna osoba bezbedno manipuliše teškim teretom bez dodatne pomoći.'
  }];
  return <section className="py-14 md:py-20 bg-dark-surface border-b border-dark-border" data-id="element-312">
      <div ref={ref} className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-313">
        <h2 className={`text-2xl md:text-3xl font-black text-white mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} data-id="element-314">
          {en ? 'How does ' : ru ? 'Как работает ' : 'Kako funkcioniše '}
          <span className="text-brand-yellow" data-id="element-315">D-TECH</span>
          {en ? ' work?' : '?'}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-316">
          {items.map((item, i) => <div key={i} className="flex flex-col gap-3 p-5 bg-dark-bg border border-dark-border rounded-industrial" style={{
          transitionProperty: 'opacity, transform',
          transitionDuration: '700ms',
          transitionDelay: `${i * 150}ms`,
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)'
        }} data-id="element-317">
              <div className="flex items-center gap-3" data-id="element-318">
                {item.icon}
                <span className="text-brand-yellow font-bold text-base" data-id="element-319">
                  {item.label}
                </span>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-320">
                {item.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}